import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../services/authentication/authentication.service';

@Component({
  selector: 'app-two-factor-approve',
  templateUrl: './two-factor-approve.component.html',
  styleUrls: ['./two-factor-approve.component.css'],
})
export class TwoFactorApproveComponent implements OnInit {
  pendingId: string = '';
  status: string = '';
  isLoading: boolean = false;
  error: string = '';
  resolved: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit(): void {
    const queryPendingId = this.route.snapshot.queryParams['pendingId'];
    if (queryPendingId) {
      this.pendingId = queryPendingId;
      this.checkStatus();
    }
  }

  checkStatus() {
    if (!this.pendingId) {
      this.error = 'Please enter a request ID.';
      return;
    }
    this.error = '';
    this.isLoading = true;
    this.authenticationService.get2FAStatus(this.pendingId).subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        this.isLoading = false;
        if (json.response.status == 'SUCCESS') {
          this.status = json.data.status;
          this.resolved = this.status !== 'PENDING';
        } else {
          this.error = json.response.displayMessage;
        }
      },
      (error) => {
        console.log(error);
        this.isLoading = false;
        this.error = 'Unable to look up this request.';
      }
    );
  }

  decide(approved: boolean) {
    if (!this.pendingId) {
      this.error = 'Please enter a request ID.';
      return;
    }
    this.error = '';
    this.isLoading = true;
    this.authenticationService.decide2FA(this.pendingId, approved).subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        this.isLoading = false;
        if (json.response.status == 'SUCCESS') {
          this.status = json.data.status;
          this.resolved = true;
        } else {
          this.error = json.response.displayMessage;
        }
      },
      (error) => {
        console.log(error);
        this.isLoading = false;
        this.error = 'Unable to submit your decision.';
      }
    );
  }
}
